import React from "react"
import { isEmail } from 'validator'
import { Button, DatePicker } from 'react-materialize';

import { formatDateForDisplay } from '../helpers/datepickerhelpers';

class UserDataForm extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.onDatePickerChange = this.onDatePickerChange.bind(this);

        this.shippingAddressFull = `${props.shipping_address}, ${props.shipping_city}, ${props.shipping_state} ${props.shipping_zip}`;
    }

    onDatePickerChange(shippingDate) {
        console.log('onDatePickerChange called', shippingDate)
        console.log('props date', this.props.shipping_date)
        // TODO: find an easier way to support zero pads without having to slice ISO-8601 formatted response
        const shippingDateYear = shippingDate.getFullYear();
        let shippingDateMonth = shippingDate.getMonth() + 1;
        if (shippingDateMonth < 10) {
            shippingDateMonth = `0${shippingDateMonth}`;
        }
        let shippingDateDate = shippingDate.getDate();
        if (shippingDateDate < 10) {
            shippingDateDate = `0${shippingDateDate}`;
        }
        const shippingDateString = `${shippingDateYear}-${shippingDateMonth}-${shippingDateDate}`

        this.props.handleShippingDateChange(shippingDateString);
    };

    renderTrackingNumberView(tracking_number) {
        if (tracking_number) {
            return <p>{tracking_number}</p>
        }

        return <p style={{color: "rgba(0,0,0,0.42)"}}>N/A</p>
    }

    render() {
        return (
            <div className="row">
                 <div className="input-field col s8">
                    Entity Name
                    <input
                        name="entity"
                        disabled
                        defaultValue={this.props.entity || ''}
                    />
                </div>
                <div className="input-field col s8">
                    County
                    <input
                        name="county"
                        disabled
                        defaultValue={this.props.county || ''}
                    />
                </div>
                <div className="input-field col s8">
                    Shipping address
                    <input
                        name="shipping_address_full"
                        disabled
                        defaultValue={this.shippingAddressFull}
                    />
                </div>
                <div className="input-field col s8">
                    Email Address
                    <input
                        name="tracking_email_display"
                        disabled
                        defaultValue={this.props.tracking_email || ''}
                    />
                </div>
                <div className="input-field col s8">
                    Phone Number
                    <input
                        name="phone_number_display"
                        disabled
                        defaultValue={this.props.phone_number || ''}
                    />
                </div>
                <div className="input-field col s8">
                    Computer Selection
                    <input
                        name="computer_selection_display"
                        disabled
                        defaultValue={this.props.computer_selection || ''}
                    />
                </div>
                <div className="input-field col s8">
                    Printer Selection
                    <input
                        name="printer_selection_display"
                        disabled
                        defaultValue={this.props.printer_selection || ''}
                    />
                </div>
                <div className="input-field col s8">
                    Computer Tracking Number
                    {this.renderTrackingNumberView(this.props.computer_tracking_number)}
                </div>
                <div className="input-field col s8">
                    Printer Tracking Number
                    {this.renderTrackingNumberView(this.props.printer_tracking_number)}
                </div>
                <form onSubmit={this.props.onSubmit} className="col s12">
                        <p className="flow-text" style={{marginBottom: 0}}>Requested Delivery Date</p>
                        {(this.props.computer_tracking_number || this.props.printer_tracking_number) &&
                            <span>
                                <p>Note: you cannot change your delivery date at this time.</p>
                                <input
                                    name="phone_number_display"
                                    disabled
                                    defaultValue={formatDateForDisplay(this.props.shippingDateOptions.defaultDate) || ''}
                                />
                            </span>
                        }
                        {(!this.props.computer_tracking_number && !this.props.printer_tracking_number) &&
                            <DatePicker
                                id="shipping_datepicker"
                                className=""
                                s={6}
                                onChange={this.onDatePickerChange}
                                options={{
                                    // format: "yyyy-mm-dd",
                                    autoClose: true,
                                    defaultDate: this.props.shippingDateOptions.defaultDate,
                                    setDefaultDate: this.props.shippingDateOptions.setDefaultDate,
                                    minDate: this.props.shippingDateOptions.minDate,
                                    maxDate: this.props.shippingDateOptions.maxDate,
                                    disableDayFn: (date) => {
                                        // Disable Saturdays and Sundays
                                        if (date.getDay() === 0 || date.getDay() === 6) {
                                            return true;
                                        }

                                        // Disable Feb 24th, 2025 specifically
                                        const feb24 = new Date(2025, 1, 24); // Month is 0-based
                                        if (date.getTime() === feb24.getTime()) {
                                            return true;
                                        }
                                        // Disable March 3rd, 2025 specifically
                                        const mar3 = new Date(2025, 2, 3); // Month is 0-based
                                        if (date.getTime() === mar3.getTime()) {
                                            return true;
                                        }

                                        // Disable blackout dates
                                        if (this.props.blackoutDates && this.props.blackoutDates.length > 0) {
                                            const dateStr = date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD
                                            return this.props.blackoutDates.includes(dateStr);
                                        }
                                        
                                        return false;
                                    }
                                }}
                                autoClose={true}
                                placeholder="Please select a date"
                                required={true}
                            />
                        }
                    <div className="row">

                    </div>
                    <p className="flow-text" style={{marginBottom: "5px"}}>Shipping Information Change</p>
                    <div className="input-field col s8">
                        Shipping Address
                        <input
                            name="shipping_address"
                            defaultValue={this.props.shipping_address || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    <div className="input-field col s5">
                        City
                        <input
                            name="shipping_city"
                            defaultValue={this.props.shipping_city || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    <div className="input-field col s1">
                        State
                        <input
                            name="shipping_state"
                            defaultValue={this.props.shipping_state || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    <div className="input-field col s2">
                        Zip Code
                        <input
                            name="shipping_zip"
                            defaultValue={this.props.shipping_zip || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    <div className="input-field col s8">
                        Email Address Change
                        <input
                            name="tracking_email"
                            // TODO: tracking_email validation here
                            defaultValue={this.props.tracking_email || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    <div className="input-field col s8">
                        Phone Number Change
                        <input
                            name="phone_number"
                            defaultValue={this.props.phone_number || ''}
                            onChange={this.props.handleInput}
                            required={true}
                        />
                    </div>
                    {this.props.errorMessage &&
                        <div className="col s12" style={{display: "flex", justifyContent: "center"}}>
                            <p style={{color: "red", fontWeight: "bold", fontSize: "1.2em"}}>{this.props.errorMessage}</p>
                        </div>
                    }
                    <div className="col s12" style={{display: "flex", justifyContent: "center"}}>
                        <Button className="btn-large">Submit</Button>
                    </div>
                </form>
            </div>
        )
    }
}

export default UserDataForm;
